<template>
  <div
    v-if="text && showHelpText()"
    v-html="compiledMarkdown(props.text!)"
    className="help-text"
  ></div>
</template>
<script setup lang="ts">
import { marked } from "marked";
import { inject } from "vue";

export type HelpTextProps = {
  text?: string;
};

const props = defineProps<HelpTextProps>();

const showHelpText = inject("showHelpText", () => false);

const compiledMarkdown = (input: string) => {
  return marked(input);
};
</script>
<style scoped>
:deep(ol),
:deep(ul) {
  margin: revert;
  padding: revert;
  list-style: revert;
}

.help-text {
  margin-bottom: 1em;
  background-color: var(--neutral-50);
  padding: 10px;
  font-size: 14px;
}
</style>
